module.exports = __webpack_public_path__ + "static/img/dice_5.944bad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/dice/dice_5.png
// module id = qPOC
// module chunks = 23